import PropTypes from "prop-types";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { bookingPropTypes, paymentShape, paymentTypesValues } from "app/utils/propTypes";
import {
	getContextCallCenter,
	getQuoteTotalWithDelta,
	getSelectedStopoverDuration,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { bindActionCreators } from "redux";
import { updateEmail } from "app/reducers/emailActionCreators";
import { saveProfileOnPayment } from "app/pages/Account/Profile/profileActionCreators";
import { mapContactFormToProfilePayload, parseAmount, trimAll } from "app/utils/utils";
import injectCountries from "app/utils/intl/InjectCountries";
import {
	book,
	bookExternalPayment,
	fetchExternalPaymentCallback,
	paymentCallback,
	sendEstimate,
	updateExternalBookStatus,
} from "app/pages/Booking/Payment/paymentActionCreators";
import Payment from "./Payment.jsx";
import {
	BOOK_EXTERNAL_PAYMENT_STATUS,
	BOOK_STATUS,
	EXTERNAL_PAYMENT_STATUS,
	FLAGSHIP_SCREENVIEW_KPIS,
	HTTP_STATUS_CODES,
	OFFER_CONTRACT_TYPES,
	PASSENGER_TYPE,
	PAYMENT_COUPON_TYPE,
	PAYMENT_METHODS,
	PRE_BOOK_CODE_STATUS,
	PROMO_CODE_STATUS,
	STRATEGY,
	USABLE_CREDITS_STATUS,
} from "app/constants";
import withRouter from "app/utils/hocs/withRouter";
import pruneEmpty from "app/utils/pruneEmpty";
import {
	sendTagOn3DSRedirect,
	sendTagOnApiCallbackError,
	sendTagOnError,
	sendTagOnExternalPayment,
	sendTagOnPaymentFailed,
} from "app/utils/analytics";
import { logout } from "app/pages/Auth/AuthActions";
import {
	getCurrentPaymentMode,
	getCurrentPaymentType,
	getEncryptedCard,
	getInsurancesSplittedPrice,
	getPaymentPriceChangeData,
} from "app/pages/Booking/Payment/paymentSelector";
import get from "lodash/get";
import {
	buildPaymentPayload,
	getPaymentErrorMessage,
	transformBookingContact,
} from "app/utils/paymentUtils";
import {
	finishLoadingBar,
	showLoadingBar,
} from "app/pages/.shared/LoadingBar/loadingBarActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { fetchFicheProduit } from "app/pages/Listing/productActionCreators";
import { isAuthenticated, isOperatorMode } from "app/pages/Auth/authSelectors";
import { getUsableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import { getVpSaleCode } from "app/reducers/partnerDataSelector";
import { preBook, showFlexRatesModal } from "app/pages/Booking/Quotation/quotationActionCreators";
import { parsePhoneNumber } from "react-phone-number-input/max";
import { fetchSDPAccommodationDescription } from "app/pages/SmartDP/smartDPActionCreators";
import { getBrandDisplayName, getPartnerMarketing } from "app/reducers/partnerSelector";
import { shouldGetProfileAtPayment } from "app/pages/Account/Profile/profileSelector";
import withFlagship from "app/utils/hocs/withFlagship";
import { HitType, useFlagship } from "@flagship.io/react-sdk";
import { connect } from "react-redux";
import { isUsaDestination } from "app/pages/FicheProduit/ficheProduitSelector";
import appGlobalsContext from "app/AppGlobalsContext";
import { isEqual } from "lodash/lang";
import isEmpty from "lodash/isEmpty";
import { dispatchBookExternalHtmlRequest } from "app/pages/Account/MyBookings/myBookingsActionCreators";
import { defaultValues, validationSchema } from "app/pages/Booking/Payment/paymentSchema";
import { Formik } from "formik";
import { getCredentials } from "app/utils/auth.js";
import {
	fetchStopoverAccommodationDescription,
	sendEstimateStopover,
	stopoverBook,
	stopoverBookExternalPayment,
	stopoverPaymentCallback,
} from "app/pages/Stopover/stopoverActionCreators";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { mapPaymentStoreToTag, mapPaymentTypesStoreToTag } from "app/utils/analytics-store-mapper";
import {
	hotelOnlyBook,
	hotelOnlyBookExternalPayment,
	hotelOnlyPaymentCallback,
	sendEstimateHotelOnly,
} from "app/pages/HotelOnly/hotelOnlyActionCreator";
import { getBookingFlowId } from "app/pages/HotelOnly/hotelOnlySelectors";
import { generateDestinationTitle } from "app/utils/productUtils";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { fetchHotelOnlyAccommodationDescription } from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";
import { differenceInDays } from "date-fns";
import { string } from "yup";
import { FIDELITY_CARD_NUMBER_VALIDATION } from "src/@brand/appConstants";

const PaymentContainer = props => {
	const {
		abTestsValues,
		bookExternalPayment = () => {},
		stopoverBookExternalPayment = () => {},
		hotelOnlyBookExternalPayment = () => {},
		updateExternalBookStatus = () => {},
		strategy = "",
		logout = () => {},
		navigate = () => {},
		updateEmail = () => {},
		booking,
		quotationCode,
		bookingFlowId,
		payment,
		location = {},
		total,
		updateBooking = () => {},
		ficheProduit = {},
		fetchFicheProduit = () => {},
		fetchHotelOnlyAccommodationDescription = () => {},
		isSDP,
		isStopover,
		isHotelOnly,
		selectedStopoverDuration,
		fetchSDPAccommodationDescription = () => {},
		fetchStopoverAccommodationDescription = () => {},
		smartDPCode,
		dispatchBookExternalHtmlRequest = () => {},
		showLoadingBar,
		finishLoadingBar,
		profile = {},
		contextCallCenter = {},
		partnerData = {},
		merchandisingCode,
		marketingSource,
		promotion = {},
		formInitialValues = {},
		selectedPaymentType,
		cartAmount,
		dateOfBirthRequired,
		showAmountToPay = false,
		book = () => {},
		paymentCallback = () => {},
		hotelOnlyPaymentCallback = () => {},
		stopoverPaymentCallback = () => {},
		isOperatorMode,
		shop,
		sendEstimate = () => {},
		sendEstimateStopover = () => {},
		sendEstimateHotelOnly = () => {},
		stopoverBook = () => {},
		hotelOnlyBook = () => {},
		exposedAbTests,
	} = props;

	const adyenComponent = useRef();

	const [isProductDataFetched, toggleProductDataFetched] = useState(false);

	const { track } = useAnalytics();

	const { sendHits } = useFlagship();

	const bookingPaymentType = booking?.paymentType;
	const bookingPaymentMode = booking?.paymentMode;
	const locationSearch = location?.search;
	const query = parseQueries(locationSearch);
	const externalPaymentStatus = query?.externalPaymentStatus;
	const { envVars, resolution } = useContext(appGlobalsContext);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const proxyBasenamePrefix = envVars.PROXY_BASENAME_PREFIX;

	const [error, setError] = useState({});
	const [updateFormInitialValues, setUpdateFormInitialValues] = useState(true);
	const setPaymentError = value => {
		setError(value);
	};

	const paymentTypes = payment.paymentTypes;
	const selectedPaymentModeValue = booking.paymentMode;

	const handleChangeValues = () => {
		if (updateFormInitialValues) {
			setUpdateFormInitialValues(false);
		}
	};

	const showExternalPaymentError = status => {
		if (status === BOOK_EXTERNAL_PAYMENT_STATUS.BOOK_EXTERNAL_PAYMENT_STATUS_REFUSED) {
			setError({
				id: "error.payment.external.technical.error.not.enough.balance",
			});
		} else if (status === BOOK_STATUS.SESSION_EXPIRED) {
			setError({
				id: "error.payment.session.expired",
			});
		} else if (
			status === EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR ||
			status === BOOK_EXTERNAL_PAYMENT_STATUS.BOOK_EXTERNAL_PAYMENT_TECHNICAL_ERROR
		) {
			const phoneNumber = contextCallCenter.displayPhone
				? contextCallCenter.displayPhone.join(" ")
				: "";
			setError({
				id: "error.payment.external",
				values: { telephone: phoneNumber },
			});
		} else if (status === BOOK_STATUS.CREDIT_CARD_INFO) {
			setError({
				id: "error.payment.credit.card.info",
			});
		} else if (status === BOOK_STATUS.CREDIT_CARD_TECHNICAL_ERROR) {
			setError({
				id: "error.payment.technical.error",
			});
		} else if (status === BOOK_STATUS.CREDIT_CARD_REFUSED) {
			setError({
				id: "error.payment.credit.card.refused.not.enough.balance",
			});
		}
	};

	const onAdyenComponentMounted = useCallback(AdyenComponent => {
		adyenComponent.current = AdyenComponent;
	}, []);

	useEffect(() => {
		sendHits([
			{
				type: HitType.PAGE_VIEW,
				documentLocation: window.location.origin + window.location.pathname,
			},
			{
				type: HitType.SCREEN_VIEW,
				documentLocation: isSDP
					? FLAGSHIP_SCREENVIEW_KPIS.SCREENVIEW_SDP_PAYMENT
					: FLAGSHIP_SCREENVIEW_KPIS.SCREENVIEW_PP_PAYMENT,
			},
		]);
	}, [isSDP]);

	const handleExternalPaymentStatus = useCallback(
		externalPaymentStatus => {
			if (externalPaymentStatus) {
				updateExternalBookStatus(externalPaymentStatus);

				if (
					externalPaymentStatus ===
						EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR ||
					externalPaymentStatus ===
						EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_ABORTED
				) {
					sendTagOnExternalPayment(externalPaymentStatus);
					showExternalPaymentError(externalPaymentStatus);
				} else if (
					externalPaymentStatus ===
					EXTERNAL_PAYMENT_STATUS.EXTERNAL_PAYMENT_STATUS_PENDING
				) {
					const handleBookExternalPayment = (bookFunction, payload) => {
						bookFunction(payload)
							.then(response => {
								if (response.status === HTTP_STATUS_CODES.OK) {
									const bookExternalPaymentStatus = response.data.status;
									const email = booking?.contact?.email;
									const bookingReference = response?.data?.bookingReference;

									sendTagOnExternalPayment(bookExternalPaymentStatus);

									if (
										[
											BOOK_STATUS.SUCCESS,
											BOOK_STATUS.WARNING_BOOKING_OK_FULLPAYMENT_FAILED,
											BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_OK,
											BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_FAILED,
											BOOK_STATUS.TECHNICAL_FAILURE,
										].includes(bookExternalPaymentStatus)
									) {
										const insurance = payment?.insurances?.insurancesItem?.find(
											insurance => insurance.code === booking?.insurance?.code
										);
										updateEmail(email);

										if (
											!isOperatorMode &&
											response?.data?.status !== BOOK_STATUS.TECHNICAL_FAILURE
										) {
											track("payment_confirmation", {
												status: bookExternalPaymentStatus,
												payment: mapPaymentStoreToTag({
													insuranceName: insurance?.name,
													paymentMode: bookingPaymentMode,
													paymentType: bookingPaymentType,
													bookingReference,
													daysBeforeDeparture: differenceInDays(
														new Date(booking?.departureDate),
														new Date()
													),
													...(promotion?.status ===
														PROMO_CODE_STATUS.SUCCESS && {
														voucherCode: promotion?.promotionCode,
														voucherDiscount: promotion?.promotionValue,
													}),
												}),
											});
										}

										navigate(
											{ pathname: "../confirmation" },
											{
												state: {
													bookingReference,
													status: bookExternalPaymentStatus,
													paymentType: bookingPaymentType,
													email,
													total,
												},
											}
										);
									} else if (
										bookExternalPaymentStatus === BOOK_STATUS.DUPLICATE_BOOKING
									) {
										const existingBooking = response.data.existingBooking || {};
										navigate(
											{ pathname: "/technical-error/duplicate-booking" },
											{
												state: {
													existingBooking: {
														...existingBooking,
														email,
													},
												},
											}
										);
									} else {
										showExternalPaymentError(bookExternalPaymentStatus);
									}
								} else if (response.status === HTTP_STATUS_CODES.FORBIDDEN) {
									logout();
									sendTagOnExternalPayment(response.status);
									navigate(
										strategy !== STRATEGY.OAUTH
											? "/home/login"
											: "/technical-error/sso"
									);
								} else {
									const httpErrorMessage = get(response, "data.message");
									sendTagOnExternalPayment(response.status);
									navigate(
										{ pathname: "/technical-error" },
										{ state: { errorMessage: httpErrorMessage } }
									);
								}
							})
							.catch(error => {
								sendTagOnApiCallbackError("/bookExternalPayment", error);
								navigate({ pathname: "/technical-error" });
							});
					};

					const payload = { code: quotationCode };

					let externalBookFunction = bookExternalPayment;

					if (isHotelOnly) {
						payload.bookingFlowId = bookingFlowId;
						externalBookFunction = hotelOnlyBookExternalPayment;
					} else if (isStopover) {
						payload.bookingFlowId = quotationCode;
						externalBookFunction = stopoverBookExternalPayment;
					}

					handleBookExternalPayment(externalBookFunction, payload);
				}
			}
		},
		[
			locationSearch,
			quotationCode,
			booking?.contact?.email,
			payment?.insurances?.insurancesItem,
			booking?.insurance?.code,
			bookingPaymentMode,
			bookingPaymentType,
			total,
			strategy,
			isStopover,
			isHotelOnly,
		]
	);

	const fetchFicheProduitData = () => {
		if (isSDP && ficheProduit.id && smartDPCode) {
			fetchSDPAccommodationDescription({
				code: smartDPCode,
				accommodationId: ficheProduit.id,
			}).then(() => toggleProductDataFetched(true));
		} else if (isStopover && ficheProduit.id && smartDPCode) {
			fetchStopoverAccommodationDescription({
				bookingFlowId: smartDPCode,
				accommodationId: ficheProduit.id,
				stopoverDuration: selectedStopoverDuration,
			}).then(() => toggleProductDataFetched(true));
		} else if (isHotelOnly && ficheProduit.id && bookingFlowId) {
			fetchHotelOnlyAccommodationDescription({
				id: ficheProduit.id,
				bookingFlowId,
			}).then(() => toggleProductDataFetched(true));
		} else if (ficheProduit.uri) {
			// fetch product info for booking aside product data like photos, name and destination
			fetchFicheProduit({ productUri: ficheProduit.uri }).then(() =>
				toggleProductDataFetched(true)
			);
		}
	};

	useEffect(() => {
		fetchFicheProduitData();

		// En effet, si le user va sur la page quote depuis une page paiement en ayant sélectionné une assurance,
		// Si il choisit d'autres prestations sur la page de quote, le prix de l'assurance peut varier une fois qu'il va
		// sur la page de paiement.
		if (booking.insurance.code) {
			const insurance = payment.insurances.insurancesItem.find(
				payment => payment.code === booking.insurance.code
			);

			if (insurance) {
				updateBooking({
					insurance,
				});
			}
		}
		return () => {
			finishLoadingBar();
		};
	}, []);

	useEffect(() => {
		if (isProductDataFetched) {
			if (externalPaymentStatus) {
				// on a besoin de s'assurer que la fiche produit soit récuperée avant de gérer le status du paiement externe
				// car l'event payment_confirmation a besoin de certaines données de la fiche produit
				const query = parseQueries(locationSearch);
				handleExternalPaymentStatus(query.externalPaymentStatus);

				track("payment_page_from_payment_provider", {
					paymentTypes: mapPaymentTypesStoreToTag(paymentTypes),
				});
			} else {
				track("payment_page", {
					paymentTypes: mapPaymentTypesStoreToTag(paymentTypes),
				});
			}
		}
	}, [isProductDataFetched]);

	const beforeSubmit = paymentValues => {
		const payload = mapContactFormToProfilePayload(
			transformBookingContact(paymentValues?.contact)
		);

		if (
			strategy !== STRATEGY.TRANSACTION_FIRST &&
			(!isEqual(pruneEmpty(profile?.name), pruneEmpty(payload?.name)) ||
				!isEqual(pruneEmpty(profile?.address), pruneEmpty(payload?.address)))
		) {
			saveProfileOnPayment({ values: payload, isSilent: true });
		}
	};

	const onSubmitSuccess = ({ response, values, adyenFlow }) => {
		// Ici on passe les données pour l'envoi de tag analytics à la page de confirmation
		// via le state de react-router
		if (response.status === HTTP_STATUS_CODES.OK) {
			// console.log("book response", response.data);

			// dans le cas du payment en plusieurs fois, on redirige vers le site du partenaire
			if (response.data.redirectPaymentURL && response.data.status === BOOK_STATUS.SUCCESS) {
				window.location = response.data.redirectPaymentURL;
			} else if (response.data.status === BOOK_STATUS.DUPLICATE_BOOKING) {
				const existingBooking = response.data.existingBooking || {};
				navigate(
					{
						pathname: "/technical-error/duplicate-booking",
					},
					{
						state: {
							existingBooking: {
								...existingBooking,
								email: values.contact.email,
							},
						},
					}
				);
			} else if (response.data.status === BOOK_STATUS.EXTERNAL_ACTION_REQUEST) {
				if (adyenFlow?.actions) {
					// adyen flow
					// Settle the advanced-flow submit promise. In this Drop-in setup the
					// auto-action-handling triggered by resolve() does not render the
					// redirect/3DS component, so we also handle the action explicitly on
					// the Drop-in (same call the api-card path below uses).
					adyenFlow.actions.resolve({
						action: response.data.action,
						resultCode: response.data?.paymentProviderResult?.code,
					});
					adyenComponent?.current?.handleAction(response.data.action);
				} else if (adyenComponent?.current) {
					// adyen-api-card
					adyenComponent.current.handleAction(response.data.action);
				}
			} else if (
				response.data.status === BOOK_STATUS.EXTERNAL_REDIRECT_REQUEST &&
				response.data.externalUrl
			) {
				sendTagOn3DSRedirect();
				navigate(
					{
						pathname: "/external-redirect",
					},
					{
						state: {
							redirectParams: response.data.params,
							externalUrl: response.data.externalUrl,
							redirectMethod: response.data.redirectMethod,
						},
					}
				);
			} else if (
				response.data.status === BOOK_STATUS.EXTERNAL_HTML_REQUEST &&
				response.data.htmlPayload // scoring casino et (3DS2)
			) {
				dispatchBookExternalHtmlRequest();

				const { callbackDelay, htmlPayload } = response.data;
				const callbackUrl = response.data.callback_url;

				fetchExternalPaymentCallback({
					callbackDelay,
					callbackUrl,
					htmlPayload,
				})
					.then(({ externalPaymentStatus, response }) => {
						// handle double external redirect for 3ds casino
						if (externalPaymentStatus === BOOK_STATUS.EXTERNAL_REDIRECT_REQUEST) {
							sendTagOn3DSRedirect();
							navigate(
								{
									pathname: "/external-redirect",
								},
								{
									state: {
										redirectParams: response.data.params,
										externalUrl: response.data.externalUrl,
										redirectMethod: response.data.redirectMethod,
									},
								}
							);
						} else if (externalPaymentStatus) {
							navigate({
								pathname: "../payment",
								search: `?externalPaymentStatus=${externalPaymentStatus}`,
							});
						}
					})
					.catch(() => {
						navigate({
							pathname: "../payment",
							search: `?externalPaymentStatus=${
								BOOK_STATUS.EXTERNAL_PAYMENT_STATUS_ERROR
							}`,
						});
					});
			} else {
				if (adyenFlow?.actions) {
					// ici on met le composant adyen en mode succcess même si le user est directement redirigé
					// vers la page de confirmation ne le laissant pas le temps de voir le status success du composant
					adyenFlow.actions.resolve({
						resultCode: response.data?.paymentProviderResult?.code,
					});
				}

				const insurance = payment.insurances.insurancesItem.find(
					insurance => insurance.code === values.insurance
				);

				// Pour préremplir le champ email de la page de confirmation
				updateEmail(values.contact.email);

				const paymentMode = values.payment.mode;
				const paymentType = values.payment.type;
				const bookingReference = response?.data?.bookingReference;

				if (!isOperatorMode && response?.data?.status !== BOOK_STATUS.TECHNICAL_FAILURE) {
					track("payment_confirmation", {
						status: response.data.status,
						payment: mapPaymentStoreToTag({
							insuranceName: insurance?.name,
							paymentMode,
							paymentType,
							bookingReference,
							daysBeforeDeparture: differenceInDays(
								new Date(booking?.departureDate),
								new Date()
							),
							...(promotion?.status === PROMO_CODE_STATUS.SUCCESS && {
								voucherCode: promotion?.promotionCode,
								voucherDiscount: promotion?.promotionValue,
							}),
						}),
					});
				}

				navigate(
					{
						pathname: "../confirmation",
					},
					{
						state: {
							bookingReference,
							status: response.data.status,
							email: values.contact.email,
							paymentType,
							total: total,
						},
					}
				);
			}
		}
	};

	const mapFormToPayload = ({
		values,
		isHotelOnly,
		isOperatorMode,
		ficheProduit,
		adyenFlowStateData,
		exposedAbTests,
	}) => {
		// Creer une copie 'values' pour éviter modifications, remplace 'contact'
		const newValues = { ...values, contact: transformBookingContact(values.contact) };

		// handle for example https://saudia.com/holidays, https://saudia.com/stopover and https://saudia.com/umrah
		const baseUrl = proxyBasenamePrefix
			? `${window.location.origin}${proxyBasenamePrefix}`
			: window.location.origin;

		const buildPaymentPayloadObject = buildPaymentPayload(trimAll(newValues), {
			strategy,
			quotationCode,
			bookingFlowId,
			partnerData,
			merchandisingCode,
			marketingSource,
			booking,
			payment,
			promotion,
			baseUrl,
			isHotelOnly,
			isMobile,
			adyenFlowStateData,
			exposedAbTests,
		});

		if (!isEmpty(abTestsValues)) {
			buildPaymentPayloadObject.abTests = abTestsValues;
		}

		// send to ops so they can retrieve product data for send estimate email
		if (isOperatorMode) {
			const destination = generateDestinationTitle(
				shop,
				ficheProduit?.country,
				ficheProduit?.region,
				ficheProduit?.resort
			);

			buildPaymentPayloadObject.product = {
				id: ficheProduit.id,
				saleId: ficheProduit.saleId,
				propertyType: ficheProduit.propertyType,
				name: ficheProduit.name,
				destination: destination,
				category: ficheProduit.category || 0,
			};

			// cas où le champ de saisie du montant est renseigné
			const creditCardAmountToPay = parseAmount(newValues?.payment?.card?.amount);

			if (creditCardAmountToPay > 0) {
				buildPaymentPayloadObject.telesalesOptions = {
					customPaymentAmount: creditCardAmountToPay,
				};
				// on envoie aussi dans payment.amount mais pas sur que ce soit utile pour le back
				buildPaymentPayloadObject.payment.amount = creditCardAmountToPay;
			}
		}

		return buildPaymentPayloadObject;
	};

	const onSubmitFail = response => {
		const httpStatus = response.status;
		const httpErrorMessage = get(response, "data.message");

		const isHttpError =
			!httpStatus ||
			httpStatus === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
			httpStatus === HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
			httpStatus === HTTP_STATUS_CODES.BAD_REQUEST;

		const phoneNumber = contextCallCenter.displayPhone
			? contextCallCenter.displayPhone.join(" ")
			: "";

		if (isHttpError) {
			navigate(
				{
					pathname: "/technical-error",
				},
				{
					state: {
						errorMessage: httpErrorMessage,
					},
				}
			); // push car on veut que le back navigateur retourne sur la page de paiement
		} else if (httpStatus === HTTP_STATUS_CODES.FORBIDDEN) {
			logout();
			if (strategy === STRATEGY.OAUTH) {
				navigate({ pathname: "/technical-error/sso" });
			} else if (strategy === STRATEGY.TRANSACTION_FIRST) {
				navigate(
					{
						pathname: "/technical-error",
					},
					{
						state: {
							errorMessage: httpErrorMessage,
						},
					}
				);
			} else {
				navigate({
					pathname: "/booking/auth",
					search: `?onauthsuccess=${location.pathname}`,
				}); // replace pour éviter un back navigateur sur la page de quotation
			}
		} else {
			setError(getPaymentErrorMessage(response, phoneNumber));
		}

		if (isHttpError) {
			sendTagOnPaymentFailed(httpStatus);
		} else if (response.data.status) {
			sendTagOnPaymentFailed(response.data.status, response.data.paymentType);
		}
	};

	const processBook = (values, { setSubmitting, setStatus }, adyenFlow) => {
		showLoadingBar();
		adyenFlow?.dropin?.setStatus("loading");

		// When the book response requires an external action (e.g. 3DS redirect/challenge),
		// the Adyen Drop-in takes over after actions.resolve(action). We must NOT reset it
		// with setStatus("ready") afterwards, otherwise the redirect/challenge is cancelled.
		let adyenIsHandlingExternalAction = false;

		beforeSubmit(values);

		track("payment_processing");

		const payload = mapFormToPayload({
			values,
			isHotelOnly,
			isOperatorMode,
			ficheProduit,
			adyenFlowStateData: adyenFlow?.state?.data,
			exposedAbTests,
		});

		let bookFunction = book;

		if (isOperatorMode) {
			if (isStopover) {
				bookFunction = sendEstimateStopover;
			} else if (isHotelOnly) {
				bookFunction = sendEstimateHotelOnly;
			} else {
				bookFunction = sendEstimate;
			}
		} else if (isHotelOnly) {
			bookFunction = hotelOnlyBook;
		} else if (isStopover) {
			bookFunction = stopoverBook;
		}

		bookFunction(payload)
			.then(response => {
				if (response.status === HTTP_STATUS_CODES.OK) {
					const status = response?.data?.status;
					if (
						response.status === HTTP_STATUS_CODES.OK &&
						status !== BOOK_STATUS.SUCCESS &&
						status !== BOOK_STATUS.DUPLICATE_BOOKING &&
						status !== BOOK_STATUS.EXTERNAL_ACTION_REQUEST &&
						status !== BOOK_STATUS.EXTERNAL_REDIRECT_REQUEST &&
						status !== BOOK_STATUS.WARNING &&
						status !== BOOK_STATUS.WARNING_BOOKING_OK_FULLPAYMENT_FAILED &&
						status !== BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_FAILED &&
						status !== BOOK_STATUS.TECHNICAL_FAILURE &&
						status !== PRE_BOOK_CODE_STATUS.FULL_FLIGHT &&
						status !== PRE_BOOK_CODE_STATUS.FULL_PROPERTY &&
						status !== PRE_BOOK_CODE_STATUS.FULL_TRANSFER &&
						status !== BOOK_STATUS.EXTERNAL_HTML_REQUEST &&
						status !== BOOK_STATUS.WARNING_BOOKING_FAILED_FULLPAYMENT_OK
					) {
						sendTagOnError(`${book.toString()} [${response.status}] : ${status}`);
						setStatus({ success: false });
						onSubmitFail(response);
					} else {
						setStatus({ success: true });

						if (isOperatorMode) {
							navigate(
								{ pathname: "../confirmation" },
								{
									state: {
										bookingReference: get(response, "data.bookingReference"),
										email: values?.contact?.email,
									},
								}
							);
						} else {
							if (response.data.status === BOOK_STATUS.EXTERNAL_ACTION_REQUEST) {
								adyenIsHandlingExternalAction = true;
							}
							onSubmitSuccess({ response, values, adyenFlow });
						}
					}
				} else {
					setStatus({ success: false });
					adyenFlow?.dropin?.setStatus("ready");
					onSubmitFail(response);
					sendTagOnError(
						`${response.config.method} ${response.config.url} : ${response.status} - ${
							response.statusText
						}`
					);
				}
			})
			.finally(() => {
				setSubmitting(false);
				// Do not reset the Drop-in while Adyen is handling an external action
				// (3DS redirect/challenge), otherwise the action is cancelled.
				if (!adyenIsHandlingExternalAction) {
					adyenFlow?.dropin?.setStatus("ready");
				}
				finishLoadingBar();
			});
	};

	const handleCreditCardSubmit = (values, { setSubmitting, setStatus }, adyenFlow = {}) => {
		processBook(values, { setSubmitting, setStatus }, adyenFlow);
	};

	const handleAdyenAdditionalDetails = (state, dropin) => {
		dropin.setStatus("loading");

		let paymentCallbackFunction = paymentCallback;
		let callbackBookingFlowId = bookingFlowId || quotationCode;

		if (isHotelOnly) {
			paymentCallbackFunction = hotelOnlyPaymentCallback;
		} else if (isStopover) {
			paymentCallbackFunction = stopoverPaymentCallback;
			callbackBookingFlowId = quotationCode;
		}

		paymentCallbackFunction({
			format: "json",
			bookingFlowId: callbackBookingFlowId,
			adyenStateDataDetails: state?.data?.details,
		})
			.then(response => {
				dropin.setStatus("ready");
				if (response?.data?.externalPaymentStatus) {
					handleExternalPaymentStatus(response?.data?.externalPaymentStatus);
				} else {
					track("payment-callback-error", {
						httpsStatus: response?.status,
					});
				}
			})
			.catch(() => {
				dropin.setStatus("ready");
				track("payment-callback-error");
			});
	};

	const handleSubmit = (values, { setSubmitting, setStatus }) => {
		if (isOperatorMode) {
			// si on est en mode operator, on veut que sendEstimate soit appelé à la soumission du formulaire
			processBook(values, { setSubmitting, setStatus });
		} else if (bookingPaymentType === PAYMENT_METHODS.ADYEN_FLOW) {
			if (adyenComponent.current.isValid) {
				adyenComponent.current.submit();
			}
		} else {
			processBook(values, { setSubmitting, setStatus });
		}
	};

	const persistPaymentData = paymentValues => {
		updateBooking({
			contact: transformBookingContact(paymentValues?.contact),
			passengers: paymentValues?.passengers,
		});

		const payload = mapContactFormToProfilePayload(
			transformBookingContact(paymentValues?.contact)
		);
		if (
			strategy !== STRATEGY.TRANSACTION_FIRST &&
			(!isEqual(pruneEmpty(profile?.name), pruneEmpty(payload?.name)) ||
				!isEqual(pruneEmpty(profile?.address), pruneEmpty(payload?.address)))
		) {
			saveProfileOnPayment({ values: payload, isSilent: true });
		}
	};
	const selectedPaymentTypeValue = paymentTypes.find(paymentType => {
		return (
			paymentType.paymentType === selectedPaymentType &&
			paymentType.terms === selectedPaymentModeValue
		);
	});

	const acceptedCreditCardTypes =
		selectedPaymentTypeValue && selectedPaymentTypeValue.acceptedCreditCardTypes;

	const validateForm = useCallback(() => {
		// pas de validation de carte de crédit si on est en mode operator / agent
		if (isOperatorMode) {
			return {};
		}
		// on valide ici le infos de la carte de credit et non pas dans un validationSchema
		// afin d'être sur d'utiliser la bonne instance de adyenComponent?.current
		if (selectedPaymentType === PAYMENT_METHODS.ADYEN_FLOW) {
			const data = adyenComponent?.current?.showValidation();

			if (!data?.isValid) {
				return {
					payment: {
						card: {
							number: {
								id: "error.payment.credit.card.invalid",
							},
						},
					},
				};
			}
		} else if (selectedPaymentType === PAYMENT_METHODS.CARD) {
			const data = adyenComponent?.current?.showValidation();

			if (!data?.state?.isValid) {
				return {
					payment: {
						card: {
							number: {
								id: "error.payment.credit.card.invalid",
							},
						},
					},
				};
			}
		} else if (selectedPaymentType === PAYMENT_METHODS.BCMC) {
			const data = adyenComponent?.current?.showValidation();

			if (!data?.state?.isValid) {
				return {
					payment: {
						cardBCMC: {
							number: {
								id: "error.payment.credit.card.invalid",
							},
						},
					},
				};
			}
		}
		return {};
	}, [selectedPaymentType, adyenComponent?.current]);

	return (
		<Formik
			initialStatus={{ success: undefined }}
			initialValues={{
				...defaultValues,
				...formInitialValues,
			}}
			validationSchema={validationSchema({
				selectedPaymentTypeValue: selectedPaymentType,
				acceptedCreditCardTypes: acceptedCreditCardTypes,
				cartAmount: cartAmount,
				dateOfBirthRequired: dateOfBirthRequired,
				showAmountToPay: showAmountToPay,
				disableInsurances: isStopover,
				disablePassengers: isHotelOnly,
				isOperatorMode: isOperatorMode,
				...(FIDELITY_CARD_NUMBER_VALIDATION && {
					fidelityCardNumberValidation: string().matches(
						FIDELITY_CARD_NUMBER_VALIDATION,
						{
							message: { id: "error.flyingBlueNumber.invalid" },
							excludeEmptyString: true,
						}
					),
				}),
			})}
			validate={validateForm}
			validateOnChange={false}
			validateOnBlur={false}
			onSubmit={handleSubmit}
			enableReinitialize={updateFormInitialValues}
		>
			{() => {
				return (
					<Payment
						{...props}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardSubmit={handleCreditCardSubmit}
						onAdyenAdditionalDetails={handleAdyenAdditionalDetails}
						persistPaymentData={persistPaymentData}
						error={error}
						setPaymentError={setPaymentError}
						handleChangeValues={handleChangeValues}
						disablePassengers={isHotelOnly}
					/>
				);
			}}
		</Formik>
	);
};

PaymentContainer.propTypes = {
	values: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	enableSponsorship: PropTypes.bool,
	profile: PropTypes.object,
	payment: paymentShape,
	total: PropTypes.number,
	boardDiscount: PropTypes.number,
	strategy: PropTypes.string,
	quotationCode: PropTypes.string,
	bookingFlowId: PropTypes.string,
	token: PropTypes.string,
	booking: bookingPropTypes,
	initializeForm: PropTypes.func,
	updateExternalBookStatus: PropTypes.func,
	updateEmail: PropTypes.func,
	sendEstimate: PropTypes.func,
	sendEstimateStopover: PropTypes.func,
	sendEstimateHotelOnly: PropTypes.func,
	showExternalPaymentError: PropTypes.func,
	bookExternalPayment: PropTypes.func,
	stopoverBookExternalPayment: PropTypes.func,
	hotelOnlyBookExternalPayment: PropTypes.func,
	logout: PropTypes.func,
	isOperatorMode: PropTypes.bool,
	updateBooking: PropTypes.func,
	finishLoadingBar: PropTypes.func,
	showLoadingBar: PropTypes.func,
	paymentCallback: PropTypes.func,
	hotelOnlyPaymentCallback: PropTypes.func,
	stopoverPaymentCallback: PropTypes.func,
	shop: PropTypes.string,
	countries: PropTypes.array,
	navigate: PropTypes.func,
	allowedPaymentTypes: PropTypes.arrayOf(PropTypes.string),
	fetchFicheProduit: PropTypes.func,
	fetchHotelOnlyAccommodationDescription: PropTypes.func,
	ficheProduit: PropTypes.object,
	fetchSDPAccommodationDescription: PropTypes.func,
	fetchStopoverAccommodationDescription: PropTypes.func,
	isSDP: PropTypes.bool,
	isStopover: PropTypes.bool,
	isHotelOnly: PropTypes.bool,
	selectedStopoverDuration: PropTypes.number,
	smartDPCode: PropTypes.string,
	saveProfileOnPayment: PropTypes.func,
	shouldGetProfileAtPayment: PropTypes.bool,
	disableFetchProfile: PropTypes.bool,
	abTestsValues: PropTypes.any,
	exposedAbTests: PropTypes.array,
	dispatchBookExternalHtmlRequest: PropTypes.func,
	contextCallCenter: PropTypes.object,
	promotion: PropTypes.object,
	merchandisingCode: PropTypes.string,
	partnerData: PropTypes.object,
	marketingSource: PropTypes.string,
	formInitialValues: PropTypes.object,
	selectedPaymentType: paymentTypesValues,
	cartAmount: PropTypes.number,
	dateOfBirthRequired: PropTypes.bool,
	showAmountToPay: PropTypes.bool,
	book: PropTypes.func,
	stopoverBook: PropTypes.func,
	hotelOnlyBook: PropTypes.func,
};

const mapStateToProps = (state, props) => {
	const { countries, location } = props;
	const booking = state.booking;
	const disableFetchProfile = props.location.pathname.includes("/booking/restoreSession");

	const shouldFetchProfile = shouldGetProfileAtPayment() && !disableFetchProfile;

	const marketing = getPartnerMarketing(state);
	const isRental = booking.offer.contractType === OFFER_CONTRACT_TYPES.RENTAL;
	const profile = state.profile;
	const bookingContact = booking?.contact;
	const profileEmail = shouldFetchProfile ? state?.email : undefined;
	const { token } = getCredentials();

	const strategy = state.partner.strategy;

	const total = getQuoteTotalWithDelta(state);

	const initialPaymentTypeValue = getCurrentPaymentType(state);

	const initialPaymentModeValue = getCurrentPaymentMode(state);

	const showInsurancesSection = state?.payment?.insurances?.insurancesItem?.length > 1;
	const usableCouponsStatus = state.usableCoupons.status;
	const totalUsableCredit = getUsableCreditsTotal(state);
	const isOperator = isOperatorMode(state);
	const enablePromotionCode = isOperator || !state.partner.disablePromotionCode;

	const defaultCouponType =
		usableCouponsStatus === USABLE_CREDITS_STATUS.SUCCESS &&
		enablePromotionCode &&
		!totalUsableCredit
			? PAYMENT_COUPON_TYPE.PROMOCODE
			: PAYMENT_COUPON_TYPE.CREDIT;

	const paymentDefaultInsurance =
		state?.payment?.insurances?.insurancesItem?.length > 0
			? state?.payment?.insurances?.insurancesItem[0]?.code
			: undefined;
	const paymentInitialCardValues = {
		card: {
			amount: "",
			maidenName: "",
			birthdate: {
				day: "",
				month: "",
				year: "",
			},
			zipCodeOfBirth: "",
			holderName: "",
			expiryMonth: "",
			expiryYear: "",
			cvc: "",
			number: "",
		},
		cardBCMC: {
			holderName: "",
			expiryMonth: "",
			expiryYear: "",
			number: "",
		},
		issuerId: "",
		swissBilling: {
			birthdate: {
				day: "",
				month: "",
				year: "",
			},
			invoiceType: "",
		},
	};
	const formInitialValues = {
		contact: {
			"honorific-prefix": bookingContact
				? bookingContact?.name?.gender
				: profile?.name?.gender,
			"family-name": bookingContact
				? bookingContact?.name?.lastName
				: profile?.name?.lastName,
			"given-name": bookingContact
				? bookingContact?.name?.firstName
				: profile?.name?.firstName,
			"address-line1": bookingContact
				? bookingContact?.address?.line1
				: profile?.address?.line1,
			"address-line2": bookingContact
				? bookingContact?.address?.line2
				: profile?.address?.line2,
			"postal-code": bookingContact
				? bookingContact?.address?.postCode
				: profile?.address?.postCode,
			"address-level2": bookingContact
				? bookingContact?.address?.city
				: profile?.address?.city,
			"country-name": bookingContact
				? bookingContact?.address?.country
				: profile?.address?.country,
			state: bookingContact ? bookingContact?.address?.state : profile?.address?.state,
			phone: bookingContact ? bookingContact?.phone : profile?.address?.phone,
			email: bookingContact ? bookingContact?.email : profileEmail,
		},
		insurance: showInsurancesSection ? booking.insurance?.code : paymentDefaultInsurance,
		coupon: booking?.coupon ? booking.coupon : defaultCouponType,
		payment: {
			mode: initialPaymentModeValue && initialPaymentModeValue.toString(),
			type: initialPaymentTypeValue,
			...paymentInitialCardValues,
		},
	};

	// on format le numero de tel avec l'indicatif de la shop avant de l'afficher.
	// si le numero n'a pas d'indicatif, alors sans ce code, on a le drapeau international d'affiché
	// au lieu du drapeau correspondant à celui de la shop
	if (formInitialValues?.contact.phone) {
		const numberAnalysis = parsePhoneNumber(
			formInitialValues.contact.phone,
			state.shop.slice(3, 5)
		);
		if (numberAnalysis) {
			formInitialValues.contact.phone = numberAnalysis.number;
		}
	}

	// Si on a aucun pays de residence, alors on initialise au pays correspond à la shop
	if (!formInitialValues?.contact["country-name"]) {
		const initialCountry = countries.find(country => {
			return country.cca2 === state.shop.slice(3, 5);
		});

		if (initialCountry) {
			formInitialValues.contact["country-name"] = initialCountry.cca2; //cca2 code pays sur 2 lettres "FR"
		}
	}

	if (!isRental) {
		const passengers = booking?.passengers;

		const adultPassengers = passengers?.filter(
			passenger => passenger?.type === PASSENGER_TYPE.ADULT
		);
		const childPassengers = passengers?.filter(
			passenger => passenger?.type === PASSENGER_TYPE.CHILD
		);
		const infantPassengers = passengers?.filter(
			passenger => passenger?.type === PASSENGER_TYPE.INFANT
		);

		let passengersFields = [
			...(Array.isArray(adultPassengers) ? adultPassengers : []),
			...(Array.isArray(childPassengers) ? childPassengers : []),
			...(Array.isArray(infantPassengers) ? infantPassengers : []),
		];

		passengersFields = passengersFields.map(item => ({
			type: item?.type || "",
			index: item?.index,
			name: {
				gender: item?.name?.gender || "",
				firstName: item?.name?.firstName || "",
				lastName: item?.name?.lastName || "",
			},
			birthdate: {
				day: item?.birthdate?.day || "",
				month: item?.birthdate?.month ?? "",
				year: item?.birthdate?.year || "",
			},
			frequentFlyerTravellerCardNumber: item?.frequentFlyerTravellerCardNumber || "",
		}));

		formInitialValues.passengers = passengersFields;
	}

	const isSDP = location.pathname.includes("/sdp/booking/payment");

	const contextCallCenter = getContextCallCenter({
		isPaymentPage: true,
	})(state);
	return {
		partnerData: state.partnerData,
		promotion: state.promotion,
		merchandisingCode: state.merchandising?.current?.code,
		isSDP,
		smartDPCode: state.smartDP.code,
		selectedStopoverDuration: getSelectedStopoverDuration(state),
		marketingSource: state.marketing?.source,
		rgpdMessagePayment: marketing?.rgpd?.paymentRgpdMessage || {},
		shop: state.shop,
		contextCallCenter,
		cartAmount: getQuoteTotalWithDelta(state),
		selectedPaymentType: booking.paymentType,
		booking: booking,
		bookingFlowId: getBookingFlowId(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		quotationCode: state.quotation.code,
		total: total,
		boardDiscount: Number(state?.booking?.board?.discount) || 0,
		token: token,
		profile: profile,
		payment: { ...state.payment, insurances: getInsurancesSplittedPrice(state) },
		resolution: state.resolution,
		showFrequentTravellerCardInput: state.payment.showFrequentTravellerCardInput,
		dateOfBirthRequired: state.payment.dateOfBirthRequired,
		isChildrenAgeRequired: state.ficheProduit.isChildAgeRequired || isSDP,
		isAuthenticated: isAuthenticated(state),
		enableSponsorship: state.partner.enableSponsorship,
		strategy: strategy,
		email: shouldFetchProfile ? state.email : undefined, // Autorise ou non la saisie de l'email
		formInitialValues,
		showInsurancesSection,
		partnerCode: state.partner.code,
		vpSaleCode: getVpSaleCode(state),
		encryptedCard: getEncryptedCard(state),
		ficheProduit: state.ficheProduit,
		usableCouponsStatus: state.usableCoupons.status,
		isOperatorMode: isOperator,
		brandDisplayName: getBrandDisplayName(state),
		shouldGetProfileAtPayment: shouldFetchProfile,
		priceChangeData: getPaymentPriceChangeData(state),
		isUsaDestination: isUsaDestination(state),
		showAmountToPay: isOperatorMode(state),
		exposedAbTests: state.abTests?.exposedTests,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			logout,
			updateEmail,
			bookExternalPayment,
			stopoverBookExternalPayment,
			hotelOnlyBookExternalPayment,
			updateExternalBookStatus,
			updateBooking,
			finishLoadingBar,
			showLoadingBar,
			fetchFicheProduit,
			fetchHotelOnlyAccommodationDescription,
			showFlexRatesModal,
			preBook,
			paymentCallback,
			hotelOnlyPaymentCallback,
			stopoverPaymentCallback,
			saveProfileOnPayment,
			fetchSDPAccommodationDescription,
			fetchStopoverAccommodationDescription,
			dispatchBookExternalHtmlRequest,
			sendEstimate,
			sendEstimateStopover,
			sendEstimateHotelOnly,
			book,
			stopoverBook,
			hotelOnlyBook,
		},
		dispatch
	);
};

export default injectCountries(
	withFlagship(
		withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentContainer)),
		"prebook_flags"
	)
);
